import React, { useEffect, useState, useContext } from 'react'
import './EventCarousel.scss'
import moment from 'moment'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { Row, Col, Carousel, CarouselItem, CarouselControl, CarouselIndicators } from 'reactstrap'
import { SPContext } from '../../SPContext'

let time = {}
const displayTime = value => ('0' + value).slice(-2)
const computeDuration = event => {
    const now = +new Date()
    let diff = moment(new Date(event.event_date_start)).format('x') - now
    if (diff < 0) {
        diff = 0
    }
    return moment.duration(diff, 'milliseconds')
}

function EventCarousel({ max_events }) {
    const { events } = useContext(SPContext)

    if (events.length > 0)
    {
        return <div></div>
    }


    const featured_events = events.filter(
        e => !!e.event_featured_flag && e.event_FK_event_status_id !== '5',
    )

    const [animating, setAnimating] = useState('')
    const [activeIndex, setActiveIndex] = useState(0)

    const lc_events = featured_events
        .reduce((carousel_events, event) => {
            const new_event = {
                id: event.event_id,
                src: event.event_featured_image || event.main_image || '/images/default_image.png',
                altText: event.event_title,
                captionHeader: event.event_title,
                captionText: '...',
                event,
            }
            carousel_events.push(new_event)
            return carousel_events
        }, [])
        .slice(0, max_events)
        .sort((a, b) => (a.event.event_date_start > b.event.event_date_start ? 1 : -1))

    if (!lc_events[activeIndex]) {
        setActiveIndex(0)
    }

    const onExiting = () => {
        setAnimating(true)
    }

    const onExited = () => {
        setAnimating(false)
    }

    const next = () => {
        if (animating) return
        const nextIndex = activeIndex === lc_events.length - 1 ? 0 : activeIndex + 1
        setActiveIndex(nextIndex)
    }

    const previous = () => {
        if (animating) return
        const nextIndex = activeIndex === 0 ? lc_events.length - 1 : activeIndex - 1
        setActiveIndex(nextIndex)
    }

    const goToIndex = newIndex => {
        if (animating) return
        setActiveIndex(newIndex)
    }

    const eventLinkButton = event_id => {
        return (
            <Row className='sp-carousel-link-div mt-3 mt-md-4 text-center'>
                <Col md={{ size: 4, offset: 4 }}>
                    <Link className='btn btn-primary' to={`/event/view/${event_id}`}>
                        tell me more!
                    </Link>
                </Col>
            </Row>
        )
    }

    // const { activeIndex } = this.state

    const carousel_item = {
        5: {
            src: '/images/birthday.jpg',
        },
        16: {
            src: '/images/mudder.jpg',
        },
        18: {
            src: '/images/barbecue.jpg',
        },
        49: {
            src: '/images/chad.jpg',
        },
        24: {
            src: '/images/blackpool-background.jpg',
        },
        32: {
            src: '/images/soapbox.jpg',
        },
    }

    const background_image = () => {
        if (
            lc_events[activeIndex] &&
            carousel_item[lc_events[activeIndex].id] &&
            carousel_item[lc_events[activeIndex].id].src
        ) {
            return carousel_item[lc_events[activeIndex].id].src
        } else if (lc_events[activeIndex]) {
            return lc_events[activeIndex].src
        }
        return ''
    }

    const CarouselContainer = styled.div`
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)),
            url(${background_image}) !important;
    `
    return (
        <CarouselContainer className='carousel-container'>
            <img src='/images/scroll.png' alt='scroll more' className='scroll-people ' />
            <Carousel
                className={
                    'sp-carousel carousel-item-' +
                    (lc_events[activeIndex] ? lc_events[activeIndex].id : 0)
                }
                activeIndex={lc_events[activeIndex] ? activeIndex : 0}
                next={next}
                previous={previous}
                interval={10000}
            >
                <CarouselIndicators
                    items={lc_events}
                    activeIndex={lc_events[activeIndex] ? activeIndex : 0}
                    onClickHandler={goToIndex}
                />
                {lc_events.map(item => (
                    <CarouselItem
                        key={`carousel-item-${item.event.event_id}`}
                        className={'sp-carousel-item'}
                        onExiting={onExiting}
                        onExited={onExited}
                    >
                        <CarouselSlide
                            item={item}
                            onExiting={onExiting}
                            onExited={onExited}
                            eventLinkButton={eventLinkButton}
                        />
                    </CarouselItem>
                ))}
                <CarouselControl
                    direction='prev'
                    directionText='Previous'
                    onClickHandler={previous}
                />
                <CarouselControl direction='next' directionText='Next' onClickHandler={next} />
            </Carousel>
        </CarouselContainer>
    )
}

const getLocation = item => {
    const { locations } = useContext(SPContext)
    if (
        item.event.event_town &&
        item.event.event_town !== 'null' &&
        item.event.event_town.length > 0
    ) {
        return item.event.event_town
    } else {
        if (item.event) {
            const lc_location =
                locations &&
                locations.find(
                    location_item =>
                        parseInt(location_item.id, 10) ===
                        parseInt(item.event.event_FK_location_id, 10),
                )

            return lc_location ? lc_location['value'] : 'N/A'
        }
    }
}

const CarouselSlide = ({ item, onExiting, onExited, eventLinkButton }) => {
    const [duration, setDuration] = useState(computeDuration(item.event))

    useEffect(() => {
        time[item.event.event_id] = setInterval(() => {
            setDuration(computeDuration(item.event))
        }, 1000)
        return () => {
            clearInterval(time[item.event.event_id])
        }
    })
    return (
        <div className='container'>
            <div className='section'>
                <Row>
                    <Col md={{ size: 10, offset: 1 }}>
                        <Row>
                            <Col
                                xs={{ size: 12 }}
                                md={{ size: 3, offset: 3 }}
                                className='date-local text-xs-center'
                            >
                                <img
                                    className='d-none d-md-inline-block'
                                    src='images/calendar.svg'
                                    alt='Calendar'
                                />{' '}
                                {moment(item.event.event_date_start).format('Do MMMM YYYY')}
                            </Col>
                            <Col md={{ size: 5 }} className='date-local d-none d-md-block'>
                                <img src='../images/location.svg' alt='Location' />{' '}
                                {getLocation(item)}
                            </Col>
                        </Row>
                        <Row>
                            <Col className='text-center mt-3'>
                                <h1>
                                    <div className='carousel-caption'>
                                        <h3>{item.captionHeader}</h3>
                                        <p className='d-none d-sm-block'>
                                            {item.event.event_summary_value}
                                        </p>
                                    </div>
                                </h1>
                            </Col>
                        </Row>
                        {eventLinkButton(item.id)}
                        <Row>
                            <Col xs={{ size: 10, offset: 1 }} md={{ size: 12, offset: 0 }}>
                                <Row className='timer-row mt-3 mt-lg-5'>
                                    <Col
                                        xs={{ size: 4, offset: 0 }}
                                        md={{ size: 2, offset: 2 }}
                                        className='timer'
                                    >
                                        <span>
                                            {(duration && Math.floor(duration.asDays())) || '00'}
                                        </span>{' '}
                                        DAYS
                                    </Col>
                                    <Col
                                        xs={{ size: 4, offset: 0 }}
                                        md={{ size: 2 }}
                                        className='timer'
                                    >
                                        <span>
                                            {(duration && displayTime(duration.hours())) || null}
                                        </span>{' '}
                                        HRS
                                    </Col>
                                    <Col
                                        xs={{ size: 4, offset: 0 }}
                                        md={{ size: 2 }}
                                        className='timer'
                                    >
                                        <span>
                                            {(duration && displayTime(duration.minutes())) || null}
                                        </span>{' '}
                                        MINS
                                    </Col>
                                    <Col md={{ size: 2 }} className='timer d-none d-md-block'>
                                        <span>
                                            {(duration && displayTime(duration.seconds())) || null}
                                        </span>{' '}
                                        SECS
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default EventCarousel
